import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=19f1cf38&"
import script from "./MainNav.vue?vue&type=script&lang=ts&"
export * from "./MainNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports